import React, { Suspense } from 'react';

const DelayedSDKWizardInternal = React.lazy(() => import(/* webpackChunkName: "sdk-wizard.async" */'./sdk-wizard-with-i18n'));

export const DelayedSDKWizard = props => (
  <Suspense fallback={<div />}>
    <DelayedSDKWizardInternal {...props} />
  </Suspense>
);
